import { Link } from 'react-router-dom';
import { ShieldCheck } from 'lucide-react';

import { useQuery } from '@/helpers/useQuery';

import { Card, CardContent, CardFooter } from '@/components/ui/card';
import { Separator } from '@/components/ui/separator';
import { Badge } from '@/components/ui/badge';
import Image from '@/components/common/Image';
import FavouriteCoachHeart from '@/app/favourites/FavouriteCoachHeart';

const CoachCard = ({ coach }) => {
  const activityId = useQuery('activityId');

  return (
    <Link
      to={`/coach/${coach.id}?activityId=${activityId}`}
      style={{ textDecoration: 'none' }}
      key={coach.id}
    >
      <Card className="relative">
        <FavouriteCoachHeart coachId={coach.id} />
        <CardContent className="p-2">
          <Image url={coach.profileImages[0]?.imageUrlMedium} />
          <Separator className="my-4" />
          <div className="flex w-full justify-between items-center mb-3">
            <div className="flex gap-2 items-baseline">
              <h2 className="text-2xl leading-none font-semibold">
                {coach.preferredName
                  ? coach.preferredName
                  : `${coach.user.firstname} ${coach.user.lastname}`}
              </h2>
            </div>
            <ShieldCheck />
          </div>
          <p className="text-sm text-muted-foreground mb-2">{coach.bioShort}</p>
          <h3>Sports</h3>
          {coach.coachActivities.map((coachActivity, index) => (
            <span
              key={coachActivity.id}
              className="text-sm text-muted-foreground"
            >
              {coachActivity.activity.title}
              {index < coach.coachActivities.length - 1 && ', '}
            </span>
          ))}
        </CardContent>
        <CardFooter className="p-2 flex justify-end">
          <Badge variant="outline">
            {coach.coachRegions.map((region) => region.region.name).join(', ')}
          </Badge>
        </CardFooter>
      </Card>
    </Link>
  );
};

export default CoachCard;
